import {ref} from "vue";

const toasts = ref<{id: string, message: string}[]>([]);
const showToast = (message: string) =>
{
    toasts.value.push({id: Math.random().toString(36).substring(2), message});
    setTimeout(() => toasts.value.shift(), 4000);
};
export {showToast, toasts};